import React from "react";

const AccessDenied = () => {
    // return <><h1>403 - Forbidden</h1></>
    return <h3>API Internal Server Error</h3>
};

export default AccessDenied;